export default "__VITE_ASSET__Q8TIv8ku__"